import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import api from '../../utils/apiClient';
import APIConstant from '../../utils/pathConstants';
import Toast from '../Shared/Toast/Toast';
import Loader from '../Shared/Loader/Loader';
import logo from '../../assets/images/Logo.svg';
import { Link, useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import CommonConfig from '../../utils/constant';

const Login = () => {
  const initialState = {
    userName: '',
    password: '',
    userNameErr: false,
    UserhelperText: '',
    passwordErr: false,
    passwordhelperText: '',
    IsPasswordSeen: false,
    openLoginConfirm: false
  };

  const [state, setState] = useState(initialState);
  const navigate = useNavigate();

  const handleCheck = (e, type) => {
    let value = e.target.value;

    if (type === 'userName') {
      if (value === '' || value === null) {
        setState((prevState) => ({
          ...prevState,
          userName: value,
          userNameErr: true,
          UserhelperText: 'Username is required',
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          userName: value,
          userNameErr: false,
          UserhelperText: '',
        }));
      }
    }

    if (type === 'Password') {
      if (value === '' || value === null) {
        setState((prevState) => ({
          ...prevState,
          password: value,
          passwordErr: true,
          passwordhelperText: 'Password is required',
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          password: value,
          passwordErr: false,
          passwordhelperText: '',
        }));
      }
    }
  };

  const validate = () => {
    let formIsValid = true;

    if (state.userName === '' || state.userName === null) {
      setState((prevState) => ({
        ...prevState,
        userNameErr: true,
        UserhelperText: 'Username is required',
      }));
      formIsValid = false;
    } else {
      setState((prevState) => ({
        ...prevState,
        userNameErr: false,
        UserhelperText: '',
      }));
    }

    if (state.password === '' || state.password === null) {
      setState((prevState) => ({
        ...prevState,
        passwordErr: true,
        passwordhelperText: 'Password is required',
      }));
      formIsValid = false;
    } else {
      setState((prevState) => ({
        ...prevState,
        passwordErr: false,
        passwordhelperText: '',
      }));
    }

    return formIsValid;
  };

  const getRecaptchaToken = () => {
    return new Promise((resolve, reject) => {
      if (!window.grecaptcha) {
        return reject(new Error('reCAPTCHA not loaded'));
      }

      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(process.env.REACT_APP_GOOGLE_SITE_KEY, { action: 'login' })
          .then(token => {
            if (!token) {
              reject(new Error('Failed to get reCAPTCHA token'));
            } else {
              resolve(token);
            }
          })
          .catch(err => reject(err));
      });
    });
  };

  const handleLogin = async (e, isAlready) => {
    e.preventDefault();
    if (!validate()) return;
    Loader.show();
    try {
      const token = await getRecaptchaToken();
    
      const loginData = {
        Phone: state.userName,
        Password: state.password,
        DeviceType: 'Web',
        isAlreadyLogin: isAlready,
        IsOTPLogin: false,
        UserType: 'User',
        RecaptchaToken: token,
      };

      if (isAlready === 'true') {
        const sessionRes = await deleteUserSession(state?.userName);
        if (!sessionRes?.success) {
          Toast.error({ message: sessionRes?.message || 'Failed to logout previous session' });
          Loader.hide();
          return;
        }
      }
      const res = await api.post(APIConstant.path.login, loginData);

      if (res.success) {
        const userData = res.data;
        localStorage.setItem('ERPLoginData', JSON.stringify(userData));
        CommonConfig.setCookie('access_token', userData?.Token.toString());
        CommonConfig.setCookie('refresh_token', userData?.RefreshToken.toString());
        CommonConfig.setCookie('refresh_token', userData?.RefreshValue.toString());
        CommonConfig.setCookie('loggedIn', true.toString())
        setTimeout(async () => {
          await CommonConfig.getUserMenu(userData, navigate,'Login');
          handleClose();
          Toast.success({ message: res.message });
          Loader.hide();
        }, 1000);
      } else {
        Toast.error({ message: res.message });
        Loader.hide();
      }
    } catch (err) {
      Loader.hide();
      if (err?.statusCode === 409) {
        setState((prevState) => ({
          ...prevState,
          openLoginConfirm: true,
        }));
      } else {
        Toast.error({ message: err.message || 'Login failed' });
      }
    } finally {
      Loader.hide();
    }

  };

  const deleteUserSession = async (userId) => {
    try {
      const data = { username: userId };
      const res = await api.post(APIConstant.path.deleteSession, data);
      return res;
    } catch (err) {
      console.error('Error deleting session:', err);
      return { success: false, message: err.message };
    }
  };

  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      openLoginConfirm: false,
    }));
  };

  const renderFooter = () => (
    <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
      <Button
        label="Cancel"
        className="btn-text-action-secondary"
        onClick={handleClose}
      />
      <Button
        label="Continue"
        className="btn-text-action-primary"
        onClick={(e) => handleLogin(e, 'true')}
      />
    </div>
  );

  return (
    <div className='auth-container'>
      <div className='p-grid p-ai-center login-background p-h-100'>
        <div className='p-col-12 p-md-7 p-h-100 p-p-0 p-d-none p-d-lg-block p-position-relative'>
          <div className='login-bg-box'>
            <div className='login-bg-text'>
              <h1>Modern and innovative learning</h1>
              <p>
                Education is a utility which makes human a personality. Education is a power and makes a person powerful. Education is a key to success and freedom from all the forces.
              </p>
            </div>
          </div>
        </div>

        <div className='p-col-12 p-md-5'>
          <div className='form-area p-col-12 p-md-9'>
            <img
              src={logo}
              alt=''
              className='img-thumbnail rounded-circle mx-auto'
            />
            <p className='form-heading my-5'>Sign in to your account</p>
            <form onSubmit={(e) => handleLogin(e, 'false')}>
              <div className='p-w-100'>
                <div className='custom-inputs'>
                  <label htmlFor='emailAddress'>Username</label>
                  <InputText
                    id='emailAddress'
                    placeholder='info@yourmail.com'
                    type='text'
                    className='p-w-100 p-mt-2'
                    maxLength={50}
                    value={state.userName}
                    onChange={(e) => handleCheck(e, 'userName')}
                  />
                </div>
                {state.userNameErr && (
                  <small
                    id='username2-help'
                    className='p-error block p-d-block p-text-left p-pt-2'
                  >
                    {state.UserhelperText}
                  </small>
                )}
              </div>

              <div className='p-w-100 p-mt-4'>
                <div className='custom-inputs password-field'>
                  <label htmlFor='password'>Password</label>
                  <InputText
                    id='password'
                    type={state.IsPasswordSeen ? 'text' : 'password'}
                    placeholder='******'
                    className='p-w-100 p-mt-2'
                    value={state.password}
                    maxLength={20}
                    onChange={(e) => handleCheck(e, 'Password')}
                  />
                  <div className='login-icons'>
                    <i className={state.IsPasswordSeen ? 'icon-view tailer-icon' : 'icon-view-off tailer-icon'}
                      onClick={() =>
                        setState((prevState) => ({
                          ...prevState,
                          IsPasswordSeen: !prevState.IsPasswordSeen,
                        }))
                      }
                    ></i>
                  </div>
                </div>
                {state.passwordErr && (
                  <small
                    id='username2-help'
                    className='p-error block p-d-block p-text-left p-pt-2'
                  >
                    {state.passwordhelperText}
                  </small>
                )}
              </div>

              <div className='p-d-flex p-ai-center p-jc-between p-my-4'>
                {/* <Link to='/forgot-password' className='forgot-box'>
                  Forgot Password?
                </Link> */}
              </div>
              <Button
                type='submit'
                className='p-w-100 login-btn'
                label='Login'
              />
            </form>
          </div>
        </div>
      </div>
      <Dialog
        visible={state.openLoginConfirm}
        onHide={handleClose}
        header={
          <div className="p-d-flex p-jc-between p-ai-center">
            <span>Login Confirmation</span>
            {/* <i
              className="pi pi-times icon-modal-close"
              onClick={handleClose}
              style={{ cursor: 'pointer' }}
            ></i> */}
          </div>
        }
        footer={renderFooter()}
        draggable={false}
        dismissableMask
        position="center"
        style={{ width: '450px' }}
      >
        <div>
          <p>
            It seems like you are already logged in on another device. Are you sure you want to logout from all other devices and continue?
          </p>
        </div>
      </Dialog>
    </div>
  );
};

export default Login;
